import api, { ApiResponse } from './api';

import { UtilityCompany } from 'entities/UtilityCompany';

interface GetUtilityCompanyListResponse {
  success: boolean;
  data: UtilityCompany[];
}

export const getUtilityCompanyListService =
  (): ApiResponse<GetUtilityCompanyListResponse> =>
    api({
      method: 'GET',
      url: 'utility-companies',
      useToken: true,
    });

interface UpdateUtilityCompanyResponse {
  success: boolean;
  data: UtilityCompany;
}

// Admin: define o desconto da energia por assinatura da distribuidora.
// `discount` é fração (0–0,9) ou null para limpar.
export const updateEnergySubscriptionDiscountService = (
  id: string,
  discount: number | null
): ApiResponse<UpdateUtilityCompanyResponse> =>
  api({
    method: 'PATCH',
    url: `utility-companies/${id}/energy-subscription-discount`,
    data: { discount },
    useToken: true,
  });

// ─── Mercado livre (ACL) — preços por distribuidora (admin) ──────────────────

export interface FreeMarketPrice {
  id: string;
  utilityCompanyId: string;
  utilityCompanyName: string;
  energyPriceMwh: number;
  managementFee: number;
  active: boolean;
  updatedAt: string;
}

interface GetFreeMarketPricesResponse {
  success: boolean;
  data: FreeMarketPrice[];
}

export const getFreeMarketPricesService =
  (): ApiResponse<GetFreeMarketPricesResponse> =>
    api({
      method: 'GET',
      url: 'free-market-prices',
      useToken: true,
    });

export const updateFreeMarketPriceService = (
  utilityCompanyId: string,
  data: { energyPriceMwh: number; managementFee: number; active: boolean }
): ApiResponse<{ success: boolean }> =>
  api({
    method: 'PATCH',
    url: `free-market-prices/${utilityCompanyId}`,
    data,
    useToken: true,
  });
